export const stripLinkquLabel = (value) =>
  String(value || "")
    .replace(/\s*\(Linkqu\)\s*/gi, " ")
    .replace(/\s+via\s+Linkqu\b/gi, " ")
    .replace(/\s+/g, " ")
    .trim();

const VA_METHOD_LABELS = {
  VA_BCA: "Bank Central Asia (BCA)",
  VA_BNC: "Bank Neo Commerce (BNC)",
  VA_BNI: "Bank Negara Indonesia (BNI)",
  VA_BRI: "Bank Rakyat Indonesia (BRI)",
  VA_BSI: "Bank Syariah Indonesia (BSI)",
  VA_CIMB: "Bank CIMB Niaga",
  VA_DANAMON: "Bank Danamon",
  VA_MANDIRI: "Bank Mandiri",
  VA_MAYBANK: "Bank Maybank",
  VA_MUAMALAT: "Bank Muamalat Indonesia",
  VA_OCBC: "Bank OCBC Indonesia",
  VA_PERMATA: "Bank Permata",
};

export const getPaymentMethodDisplayName = (method) => {
  const code = String(method?.code || "")
    .toUpperCase()
    .replace(/_LINKQU$/, "");

  return VA_METHOD_LABELS[code] || stripLinkquLabel(method?.name || method);
};

// Keeps short, all-caps tokens as-is (bank acronyms: BCA, BNI, BRI, CIMB, ...);
// title-cases longer ones (Mandiri, Maybank, Danamon, ...).
const titleCaseWord = (word) => {
  if (!word) return word;
  if (word.length <= 4 && word === word.toUpperCase()) {
    return word;
  }
  return word[0].toUpperCase() + word.slice(1).toLowerCase();
};

// Short display name for compact layouts (e.g. mobile payment method rows).
// Only reshapes VA/bank names ("VA BCA" -> "BCA", "VA MANDIRI" -> "Mandiri") —
// other methods (e-wallets, retail, etc.) are returned as-is so intentional
// brand casing (e.g. "GoPay") isn't mangled.
export const getPaymentMethodShortName = (method) => {
  const rawName = stripLinkquLabel(method?.name || method);
  const vaMatch = rawName.match(/^VA\s+(.+)$/i);

  if (!vaMatch) {
    return rawName;
  }

  return vaMatch[1].split(" ").map(titleCaseWord).join(" ");
};
